export default "__VITE_ASSET__DUW7Psma__"